export const connectors = [
  {
    name: "Power BI",
    header: "Power BI",
    website: "https://powerbi.microsoft.com",
    description:
      "Transform your data into stunning visualizations with Power BI integration, enabling interactive dashboards and real-time analytics.",
    status: "Connect",
    logo: "/logos/powerbi.svg",
    intergration: {
      url: "/api/v1/integrations/connect/powerbi",
    },
    type: "BI",
  },
  {
    name: "Tableau",
    header: "Tableau",
    website: "https://www.tableau.com",
    description:
      "Visualize and explore data like never before with Tableau integration, delivering interactive dashboards and actionable insights.",
    status: "Connect",
    logo: "/logos/tableau.svg",
    intergration: {
      url: "/api/v1/integrations/connect/tableau",
    },
    type: "BI",
  },
  {
    name: "Qlik",
    header: "Qlik",
    website: "https://www.qlik.com",
    description:
      "Unlock the power of data with Qlik integration, offering advanced analytics, interactive visualizations, and real-time insights for smarter decision-making.",
    status: "Connect",
    logo: "/logos/qlik.svg",
    intergration: {
      url: "/api/v1/integrations/connect/qlik",
    },
    type: "BI",
  },
  {
    name: "Google Big Query",
    header: "Google BigQuery",
    website: "https://console.cloud.google.com/bigquery",
    description:
      "Harness the power of Google BigQuery for large-scale data analysis, enabling fast SQL queries and real-time insights.",
    status: "Connect",
    logo: "/logos/bigquery.svg",
    intergration: {
      url: "/api/v1/databot/connections",
    },
    type: "DATA_WAREHOUSE",
  },
  {
    name: "Snowflake",
    header: "Snowflake",
    website: "https://www.snowflake.com",
    description:
      "Snowflake enables organizations to learn, build, and connect with their data-driven peers. Collaborate, build insights, and scale.",
    status: "Connect",
    logo: "/logos/snowflake.svg",
    intergration: {
      url: "/api/v1/integrations/connect/snowflake",
    },
    type: "DATA_WAREHOUSE",
  },
  {
    name: "Excel",
    header: "Microsoft Excel",
    website: "https://excel.cloud.microsoft",
    description:
      "Easily manage and analyze data by integrating Excel for powerful spreadsheet capabilities and advanced calculations.",
    status: "Connect",
    logo: "/logos/excel.svg",
    intergration: {
      url: "/api/v1/integrations/connect/excel",
    },
    type: "FILES",
  },
  {
    name: "Airtable",
    header: "Airtable",
    website: "https://airtable.com",
    description:
      "Organize and manage projects with Airtable integration, offering flexible databases and real-time collaboration tools.",
    status: "Connect",
    logo: "/logos/airtable.svg",
    intergration: {
      url: "/api/v1/integrations/connect/airtable",
    },
    type: "PRODUCTIVITY",
  },
  {
    name: "Hubspot",
    header: "HubSpot",
    website: "https://www.hubspot.com",
    description:
      "Enhance your customer relationship management with HubSpot integration, enabling seamless lead tracking and marketing automation.",
    status: "Connect",
    logo: "/logos/hubspot.svg",
    intergration: {
      url: "/api/v1/connectors/hubspot/connect",
    },
    type: "CRM",
  },
  {
    name: "Salesforce",
    header: "Salesforce",
    website: "https://www.salesforce.com",
    description:
      "Connect to Salesforce for advanced customer data management, sales tracking, and actionable insights.",
    status: "Connect",
    logo: "/logos/salesforce.svg",
    intergration: {
      url: "/api/v1/integrations/connect/salesforce",
    },
    type: "CRM",
  },
  {
    name: "Notion",
    header: "Notion",
    website: "https://www.notion.so",
    description:
      "Centralize your notes, tasks, and projects by integrating Notion into your workflow for improved productivity and organization.",
    status: "Connect",
    logo: "/logos/notion.svg",
    intergration: {
      url: "/api/v1/integrations/connect/notion",
    },
    type: "PRODUCTIVITY",
  },
  {
    name: "Slack",
    header: "Slack",
    website: "https://slack.com",
    description:
      "Streamline team communication and collaboration by integrating Slack into your workflow for instant updates.",
    status: "Connect",
    logo: "/logos/slack.svg",
    intergration: {
      url: "/api/v1/integrations/connect/slack",
    },
    type: "PRODUCTIVITY",
  },
  {
    name: "Google Sheets",
    header: "Google Sheets",
    website: "https://sheets.google.com",
    description:
      "Connect a Google Sheet to bring its data, formulas, and charts into your knowledge graph.",
    status: "Connect",
    logo: "/logos/google_sheets.svg",
    intergration: {
      url: "/api/v1/integrations/connect/google_sheets",
    },
    type: "FILES",
  },
  {
    name: "CSV",
    header: "CSV",
    website: "",
    description:
      "Upload a CSV file to connect your spreadsheet data directly to MagicBI for instant analysis.",
    status: "Connect",
    logo: "/logos/csv.svg",
    intergration: {
      url: "/api/v1/integrations/connect/csv",
    },
    type: "FILES",
  },
];
